/**
 * 榜单列表
 * data-threshold优先级高于实例化时候传入的统一配置参数。
 */
define(function(require, exports, module) {
    var Base = require('c-base');
    var http = require('../../base/http');

    const RankList = Base.extend({
        defaults: {
            wrap: '',
            content: '[node-id=list]',
            loading: '[node-id=loading]',
            error: '[node-id=error]',
            end: '[node-id=end]',
            empty: '[node-id=empty]',
            threshold: 300,
            minSize: 3,
            infiniteScroll: true, // 默认无线滚动列表
            itemEmptyTpl: function() {
                return '';
            },
            itemTpl: function() {
                return ''
            },
            getListData: function(data) {
                return data.hostList;
            },
            url: ''
        },

        initialize() {
            let self = this;
            self.Parent.apply(self, arguments);

            let nodeWrap = this.nodeWrap = $(this.get('wrap'));
            let nodeContent = this.nodeContent = nodeWrap.find(this.get('content'));

            this.nodeLoading = nodeWrap.find(this.get('loading'));
            this.nodeError = nodeWrap.find(this.get('error'));
            this.nodeEnd = nodeWrap.find(this.get('end'));
            this.nodeEmpty = nodeWrap.find(this.get('empty'));

            let params = nodeContent.data('params');

            if (params) {
                this.params = eval("(" + params + ")");
                this.acid = this.params.eventId.split(':')[0];
            }

            this.pageCount = nodeContent.data('pagesize');
            this.threshold = nodeContent.data('threshold') || this.get('threshold');
            this.minSize = nodeContent.data('minsize') || this.get('minSize');
            this.infiniteScroll = nodeContent.data('infinite-scroll') || this.get('infiniteScroll');
            // 逻辑判断状态
            this.dataOver = false;
            this.dataLoading = true;
            this.isFirst = true;

            this.page = 1;
            this.dataArr = [];

            this._showLoading();

            return this;
        },
        /**
         * 渲染UI
         */
        render() {

            UpAct.loading.show();
            this.loadDataFromServer();
            this.bindEvent();

            return this;
        },
        /**
         * 从服务器端获取数据
         */
        loadDataFromServer() {
            let page = this.page;

            let params = Object.assign({}, this.params, {
                index: page,
                pageCount: this.pageCount,
            });
            let promise = http.fetch({
                url: this.get('url'),
                data: params
            });


            promise.done((res) => {
                if (res.code == 'SC_SUCCESS') {
                    let list = this.getListData(res.data);
                    let rData = this.formatList(list);

                    this.dataLoading = false;

                    this.dataArr = this.dataArr.concat(rData);

                    if (rData.length < this.pageCount) {
                        // 没有更多：列表大小 < 页码
                        this.dataOver = true;

                        this._hideLoading();

                        if (!this.isFirst) {
                            // 没有更多数据了哦
                            this._showEnd();
                        }
                    }

                    if (this.isFirst) {
                        this.isFirst = false;

                        if (rData.length == 0) {
                            // 第一页数据为空
                            this._hideLoading();
                            this._showEmpty();

                        }
                        this.renderList(page, rData, 0);
                    } else {
                        this.renderList(page, rData, 1);
                    }

                    if (!this.infiniteScroll) {
                        this._hideLoading();
                    }
                }

                UpAct.loading.hide();
            });

            promise.fail(() => {
                UpAct.loading.hide();
                this._hideLoading();
                this._showError();
            });

            this.page++;
        },
        /**
         * 全部刷新列表
         */
        refresh() {
            let pageCount = this.dataArr.length || this.pageCount;
            let params = Object.assign({}, this.params, {
                index: 1,
                pageCount: pageCount,
            });

            let promise = http.fetch({
                url: this.get('url'),
                data: params
            });

            UpAct.loading.show();

            this.dataLoading = true;
            
            promise.done((res) => {
                if (res.code == 'SC_SUCCESS') {
                    let list = this.getListData(res.data);
                    let rData = this.formatList(list);

                    this.dataArr = rData;

                    this.renderList(1, rData, 0);
                }
                UpAct.loading.hide();
                this.dataLoading = false;
            });

            promise.fail(() => {
                UpAct.loading.hide();
                this._hideLoading();
                this._showError();
                this.dataLoading = false;
            });
        },
        /**
         * 获取列表数据
         */
        getListData(data) {
            return this.get('getListData').call(this, data);
        },
        /**
         *  解析列表数据
         */
        formatList(data) {
            if (data && data.length > 0) {
                data.forEach((item, index) => {
                    item.avatar = item.avatar || UpAct.img.defaultSrc;
                });
            }

            return data;
        },
        /**
         * 渲染列表内容
         * @param data 数据
         * @param append 是否插入到列表中
         */
        renderList(page, data, append) {
            let self = this;
            let nodeContent = this.nodeContent;
            let pageCount = this.pageCount;
            let itemTpl = this.get('itemTpl');
            let itemEmptyTpl = this.get('itemEmptyTpl')
            let nodeList = $('<ul>');
            let dataNum = data.length;

            $.each(data, function(i, item) {
                item.index = (i + 1) + (page - 1) * pageCount;

                let nodeItem = itemTpl({
                    data: item,
                    acid: self.acid
                });
                if (nodeItem) {
                    nodeList.append(nodeItem);
                }
            });

            if (page == 1 && dataNum < this.minSize) {
                for (let i = 0; i < this.minSize - dataNum; i++) {
                    let nodeItem = itemEmptyTpl({
                        data: {
                            index: i + dataNum + 1
                        }
                    });
                    if (nodeItem) {
                        nodeList.append(nodeItem);
                    }
                }
            }

            if (append) {
                nodeContent.append(nodeList);
            } else {
                nodeContent.html(nodeList);
            }

            if (!this.imgHelper) {
                this.imgHelper = UpAct.img();
            } else {
                this.imgHelper.start();
            }

            if (!this.gradeHelper) {
                this.gradeHelper = UpAct.grade();
            } else {
                this.gradeHelper.start();
            }

            nodeList.attr({
                'data-showing': '1',
                'data-page': page
            });
        },

        bindEvent() {

            if (this.infiniteScroll) {
                $(window).off("scroll");
                $(window).on("scroll", () => {
                    this.scroll();
                });
            }
        },

        scroll() {
            this.timer && clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                if (this.dataOver) {
                    return;
                }
                if (this.dataLoading) {
                    return;
                }
                let body = document.body,
                    docElement = document.documentElement;
                let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
                // 700 在页面滑到底部前700px就可以加载,增加交互流畅性
                if (scrollTop > docElement.offsetHeight - docElement.clientHeight - this.get('threshold')) {
                    this.dataLoading = true;
                    this.loadDataFromServer();
                }
            }, 300);
        },
        /**
         * 显示loading
         */
        _showLoading: function() {
            if (this.nodeLoading) {
                this.nodeLoading.removeClass('hidden');
            }
        },
        /**
         * 隐藏loading
         */
        _hideLoading: function() {
            if (this.nodeLoading) {
                this.nodeLoading.addClass('hidden');
            }
        },
        /**
         * 显示数据为空的文案
         */
        _showEmpty: function() {
            if (this.nodeEmpty) {
                this.nodeEmpty.removeClass('hidden');
            }
        },
        /**
         * 隐藏数据为空的文案
         */
        _hideEmpty: function() {
            if (this.nodeEmpty) {
                this.nodeEmpty.addClass('hidden');
            }
        },
        /**
         * 显示数据异常的文案
         */
        _showError: function() {
            if (this.nodeError) {
                this.nodeError.removeClass('hidden');
            }
        },
        /**
         * 隐藏数据异常的文案
         */
        _hideError: function() {
            if (this.nodeError) {
                this.nodeError.addClass('hidden');
            }
        },
        /**
         * 显示数据加载完的文案
         */
        _showEnd: function() {
            if (this.nodeEnd) {
                this.nodeEnd.removeClass('hidden');
            }
        },
        /**
         * 隐藏数据加载完的文案
         */
        _hideEnd: function() {
            if (this.nodeEnd) {
                this.nodeEnd.addClass('hidden');
            }
        }
    });

    module.exports = RankList;

});



// WEBPACK FOOTER //
// ./js/component/base/ranklist.js